export default __webpack_public_path__ + "static/laffayette_comic_pro-webfont-acb0358befa549c1fc99fa7d77b005e6.woff";